import { withSearch } from '@elastic/react-search-ui';
import DropDownFacetFilters from '../../../components/filter/DropDownFacetFilter';

function HeritageGatewayMaritimeCraftPeriod({
  setFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <DropDownFacetFilters
      facets={facets}
      fieldId="maritimeCraftPeriod"
      filters={filters}
      formHint="For example, period example 1, period example 2, period example 3"
      id="maritime-craft-period"
      label="Period"
      removeFilter={removeFilter}
      setFilter={setFilter}
      sort={true}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, facets, filters }) => ({
  setFilter,
  removeFilter,
  facets,
  filters,
}))(HeritageGatewayMaritimeCraftPeriod);
